import React, { useState } from "react";
import styles from "./Accordion.module.css";
import accordionData from "./accordionData";
import accordionVisionData from "./accordionVisionData";

const Accordion = ({ orgId }) => {
  
  const [activeMain, setActiveMain] = useState(null);
  const [activeFAQ, setActiveFAQ] = useState(null);
  const toggleMainAccordion = (index) => {
    setActiveMain(activeMain === index ? null : index);
  };

  const toggleFAQAccordion = (index) => {
    setActiveFAQ(activeFAQ === index ? null : index);
  };

  const itemStyle = {
    borderBottom:
      Number(orgId) === 1074 ? "2px solid white" : "2px solid #6ba543", 
  };

  const linkifyText = (text) => {
    const urlRegex = /(https?:\/\/[^\s]+)/g;
    const parts = text.split(urlRegex);

    return parts.map((part, index) =>
      urlRegex.test(part) ? (
        <a
          key={index}
          href={part}
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: "white", textDecoration: "underline" }}
        >
          {part}
        </a>
      ) : (
        part
      )
    );
  };

  return (
    <div className={styles.accordion}>
      {
        orgId == 1114 ? 
        accordionVisionData.map((item, index) => (
        <div key={index} className={styles.item} style={itemStyle}>
          <div
            className={styles.header}
            onClick={() => toggleMainAccordion(index)}
          >
            <h2>{item.title}</h2>
            <span className={styles.icon}>
              {activeMain === index ? "−" : "+"}
            </span>
          </div>
          <div
            className={`${styles.content} ${
              activeMain === index ? styles.active : ""
            }`}
          >
            {item.title === "Frequently Asked Questions" ? (
              item.content.map((faq, faqIndex) => (
                <div key={faqIndex} className={styles.faqItem}>
                  <div
                    className={styles.subHeader}
                    onClick={() => toggleFAQAccordion(faqIndex)}
                  >
                    <h4 className={styles.question}>{faq.question}</h4>
                    <span className={styles.icon}>
                      {activeFAQ === faqIndex ? "−" : "+"}
                    </span>
                  </div>
                  <div
                    className={`${styles.subContent} ${
                      activeFAQ === faqIndex ? styles.active : ""
                    }`}
                  >
                    <ul>
                      {faq.answer.map((ans, ansIndex) => (
                        <li key={ansIndex}>{linkifyText(ans)}</li>
                      ))}
                    </ul>
                  </div>
                </div>
              ))
            ) : (
              <ul>
                {item.content.map((text, idx) => (
                  <li key={idx}>{text}</li>
                ))}
              </ul>
            )}
          </div>
        </div>
      ))
        : accordionData.map((item, index) => (
        <div key={index} className={styles.item} style={itemStyle}>
          <div
            className={styles.header}
            onClick={() => toggleMainAccordion(index)}
          >
            <h2>{item.title}</h2>
            <span className={styles.icon}>
              {activeMain === index ? "−" : "+"}
            </span>
          </div>
          <div
            className={`${styles.content} ${
              activeMain === index ? styles.active : ""
            }`}
          >
            {item.title === "Frequently Asked Questions" ? (
              item.content.map((faq, faqIndex) => (
                <div key={faqIndex} className={styles.faqItem}>
                  <div
                    className={styles.subHeader}
                    onClick={() => toggleFAQAccordion(faqIndex)}
                  >
                    <h4 className={styles.question}>{faq.question}</h4>
                    <span className={styles.icon}>
                      {activeFAQ === faqIndex ? "−" : "+"}
                    </span>
                  </div>
                  <div
                    className={`${styles.subContent} ${
                      activeFAQ === faqIndex ? styles.active : ""
                    }`}
                  >
                    <ul>
                      {faq.answer.map((ans, ansIndex) => (
                        <li key={ansIndex}>{linkifyText(ans)}</li>
                      ))}
                    </ul>
                  </div>
                </div>
              ))
            ) : (
              <ul>
                {item.content.map((text, idx) => (
                  <li key={idx}>{text}</li>
                ))}
              </ul>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default Accordion;
